import styled from 'styled-components'

import { theme } from '../../theme'
import TouchableOpacity from '../TouchableOpacity'

export const Button = styled(TouchableOpacity)`
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid ${theme('colors.ivory')};

  font-size: 14px;
  font-weight: 600;
  text-align: center;

  &:not(:only-child):not(:last-child) {
    border-right: 1px solid ${theme('colors.ivory')};
  }
`

export const Primary = styled(Button)`
  color: ${theme('colors.green')};
`

export const Secondary = styled(Button)`
  color: ${theme('colors.stone')};
`

export const Danger = styled(Button)`
  color: ${theme('colors.red')};
`

export const Row = styled.div`
  bottom: 0;
  display: flex;
  flex-direction: row;
  position: absolute;
  width: 100%;
`

export const Col = styled.div`
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 200%;
  margin-bottom: -50px;

  @media (max-width: ${theme('breakpoints.sm')}px) {
    margin-bottom: -30px;
  }
`

export default {
  Button,
  Danger,
  Primary,
  Row,
  Col,
  Secondary,
}
